<template>
  <ui-menu
    v-model="showContextMenu"
    :transition="false"
    :items="contextMenuFiltered"
    :menu-props="{
      menuWidth: 0,
      eager: true,
    }"
  ></ui-menu>
</template>

<script setup lang="ts">
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { useMenuReportActions, type MenuReportRowAction } from '@/composables';
import { $emitter } from '@/services/emitter';

const { itemActions, itemMenu } = useMenuReportActions();

const showContextMenu = ref(false);

const contextMenu = computed((): MenuReportRowAction[] => [
  itemActions.value.drilldownHome,
  itemActions.value.drilldown,
  itemActions.value.excludeHome,
  itemActions.value.exclude,
  itemActions.value.edit,
].concat(itemMenu.value as MenuReportRowAction[]));

const contextMenuFiltered = computed(() =>
  contextMenu.value.filter(
    (item) => typeof item.showCondition === 'undefined' || item.showCondition,
  ),
);

const onBusClearRowContext = () => {
  showContextMenu.value = false;
};

const rowContextMenu = (_data: unknown, _top: number, _left: number) => {
  showContextMenu.value = false;

  nextTick(() => {
    showContextMenu.value = true;
  });
};

onMounted(() => {
  $emitter.on('row-contextmenu', rowContextMenu);
  $emitter.on('clear-row-context', onBusClearRowContext);
});

onBeforeUnmount(() => {
  $emitter.off('row-contextmenu', rowContextMenu);
  $emitter.off('clear-row-context', onBusClearRowContext);
});
</script>
